import { default as _91mtu_93fxicBoiAcbMeta } from "/azp/_work/1/s/majority-com/pages/[country]/[mtu].vue?macro=true";
import { default as indexFMeeESBMREMeta } from "/azp/_work/1/s/majority-com/pages/[country]/index.vue?macro=true";
import { default as international_45callingWS8XKxWzz7Meta } from "/azp/_work/1/s/majority-com/pages/[country]/international-calling.vue?macro=true";
import { default as majority_45accountB33dCiH7vOMeta } from "/azp/_work/1/s/majority-com/pages/[country]/majority-account.vue?macro=true";
import { default as majority_45payYa8KahPM1nMeta } from "/azp/_work/1/s/majority-com/pages/[country]/majority-pay.vue?macro=true";
import { default as money_45transfersIY6PdFMQgZMeta } from "/azp/_work/1/s/majority-com/pages/[country]/money-transfers.vue?macro=true";
import { default as visa_45debit_45cardBqwZJBS391Meta } from "/azp/_work/1/s/majority-com/pages/[country]/visa-debit-card.vue?macro=true";
import { default as _91slug_93fINqKCmuNlMeta } from "/azp/_work/1/s/majority-com/pages/campaign/[slug].vue?macro=true";
import { default as cuba8edniKWJWZMeta } from "/azp/_work/1/s/majority-com/pages/campaign/cuba.vue?macro=true";
import { default as nigeriaUxcOrOzbN5Meta } from "/azp/_work/1/s/majority-com/pages/campaign/nigeria.vue?macro=true";
import { default as _91slug_93kHxohGOg5lMeta } from "/azp/_work/1/s/majority-com/pages/community/[slug].vue?macro=true";
import { default as _91slug_93jKHv5TAB8EMeta } from "/azp/_work/1/s/majority-com/pages/community/article/[slug].vue?macro=true";
import { default as _91slug_93iIfGaqphoNMeta } from "/azp/_work/1/s/majority-com/pages/community/discount/[slug].vue?macro=true";
import { default as _91slug_93LqbBBI3vCPMeta } from "/azp/_work/1/s/majority-com/pages/community/event/[slug].vue?macro=true";
import { default as indexnG7smlq6kVMeta } from "/azp/_work/1/s/majority-com/pages/community/index.vue?macro=true";
import { default as _91slug_93w9AuihdNk1Meta } from "/azp/_work/1/s/majority-com/pages/community/majority-tv/[slug].vue?macro=true";
import { default as migrant_45handbookKMhbjLMhEpMeta } from "/azp/_work/1/s/majority-com/pages/community/migrant-handbook.vue?macro=true";
import { default as _91slug_93cCPN872hGiMeta } from "/azp/_work/1/s/majority-com/pages/community/tag/[slug].vue?macro=true";
import { default as applySGVcLNWVuJMeta } from "/azp/_work/1/s/majority-com/pages/company/career/apply.vue?macro=true";
import { default as indexWCwmj7dINQMeta } from "/azp/_work/1/s/majority-com/pages/company/career/index.vue?macro=true";
import { default as _91slug_93Ojf2gG21BQMeta } from "/azp/_work/1/s/majority-com/pages/company/career/position/[slug].vue?macro=true";
import { default as indexNV1P6mUC8JMeta } from "/azp/_work/1/s/majority-com/pages/company/index.vue?macro=true";
import { default as indexBloo3FVsqVMeta } from "/azp/_work/1/s/majority-com/pages/data-deletion/index.vue?macro=true";
import { default as _91slug_939zMMbAiMXZMeta } from "/azp/_work/1/s/majority-com/pages/help/article/[slug].vue?macro=true";
import { default as _91subcategory_93KcvZMZQsqwMeta } from "/azp/_work/1/s/majority-com/pages/help/category/[slug]/[subcategory].vue?macro=true";
import { default as indexKJveditLSuMeta } from "/azp/_work/1/s/majority-com/pages/help/category/[slug]/index.vue?macro=true";
import { default as indexjyFB3DGcTWMeta } from "/azp/_work/1/s/majority-com/pages/help/index.vue?macro=true";
import { default as searchsSSJdtOaf4Meta } from "/azp/_work/1/s/majority-com/pages/help/search.vue?macro=true";
import { default as indexSr6B4p1L8rMeta } from "/azp/_work/1/s/majority-com/pages/index.vue?macro=true";
import { default as _91slug_93ibzcqqyNeZMeta } from "/azp/_work/1/s/majority-com/pages/internal/library/[slug].vue?macro=true";
import { default as _91country_93ILZOLPCEN1Meta } from "/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/[country].vue?macro=true";
import { default as indexYQAkQFdmdfMeta } from "/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/index.vue?macro=true";
import { default as submit_45tickettSSQNvkTlQMeta } from "/azp/_work/1/s/majority-com/pages/internal/submit-ticket.vue?macro=true";
import { default as verify_45email5htISovhS0Meta } from "/azp/_work/1/s/majority-com/pages/internal/verify-email.vue?macro=true";
import { default as calling_45ratesYO6pSj65G5Meta } from "/azp/_work/1/s/majority-com/pages/international-calling/calling-rates.vue?macro=true";
import { default as indexWA6BnUyzN5Meta } from "/azp/_work/1/s/majority-com/pages/international-calling/index.vue?macro=true";
import { default as unlimitedTarH0uC4RyMeta } from "/azp/_work/1/s/majority-com/pages/international-calling/unlimited.vue?macro=true";
import { default as team_45majorityBWmiPTAFC2Meta } from "/azp/_work/1/s/majority-com/pages/legal/privacy-policy/team-majority.vue?macro=true";
import { default as team_45majorityJU7Fins4iiMeta } from "/azp/_work/1/s/majority-com/pages/legal/terms-and-conditions/team-majority.vue?macro=true";
import { default as indexrWut2IKrUiMeta } from "/azp/_work/1/s/majority-com/pages/locations/index.vue?macro=true";
import { default as get_45paid_45earlyWnUDYQsEUrMeta } from "/azp/_work/1/s/majority-com/pages/majority-account/get-paid-early.vue?macro=true";
import { default as indexfILmjjvnkOMeta } from "/azp/_work/1/s/majority-com/pages/majority-account/index.vue?macro=true";
import { default as no_45hidden_45feesnPhZVHZMfIMeta } from "/azp/_work/1/s/majority-com/pages/majority-account/no-hidden-fees.vue?macro=true";
import { default as no_45ssnPCCUzpu1TXMeta } from "/azp/_work/1/s/majority-com/pages/majority-account/no-ssn.vue?macro=true";
import { default as indexPwSNYCGIeoMeta } from "/azp/_work/1/s/majority-com/pages/majority-pay/index.vue?macro=true";
import { default as indexeLTdsRkRJuMeta } from "/azp/_work/1/s/majority-com/pages/membership/[country]/index.vue?macro=true";
import { default as indexHOchfYt3YmMeta } from "/azp/_work/1/s/majority-com/pages/membership/index.vue?macro=true";
import { default as index3dpQQTWCQkMeta } from "/azp/_work/1/s/majority-com/pages/mobile-top-ups/index.vue?macro=true";
import { default as indexNIiGoS86GaMeta } from "/azp/_work/1/s/majority-com/pages/money-transfers/index.vue?macro=true";
import { default as indexeRC53bGafdMeta } from "/azp/_work/1/s/majority-com/pages/personalized-advisor/index.vue?macro=true";
import { default as _91category_939yCLdaFxc5Meta } from "/azp/_work/1/s/majority-com/pages/press/[category].vue?macro=true";
import { default as _91slug_93u8ETaza4MoMeta } from "/azp/_work/1/s/majority-com/pages/press/article/[slug].vue?macro=true";
import { default as indexZ0fnaTzJDzMeta } from "/azp/_work/1/s/majority-com/pages/press/index.vue?macro=true";
import { default as _91category_93AkJxdDm0DRMeta } from "/azp/_work/1/s/majority-com/pages/press/material/[category].vue?macro=true";
import { default as _91slug_93Uivqn8BKXfMeta } from "/azp/_work/1/s/majority-com/pages/press/tag/[slug].vue?macro=true";
import { default as team_45majorityCSUsuaGXSJMeta } from "/azp/_work/1/s/majority-com/pages/privacy-policy/team-majority.vue?macro=true";
import { default as indexDCMBNp3blTMeta } from "/azp/_work/1/s/majority-com/pages/referral/index.vue?macro=true";
import { default as indexrHiq7uVcdtMeta } from "/azp/_work/1/s/majority-com/pages/t/index.vue?macro=true";
import { default as team_45majoritydfowbWQZUoMeta } from "/azp/_work/1/s/majority-com/pages/terms-and-conditions/team-majority.vue?macro=true";
import { default as _91slug_93aoQl1tAxDkMeta } from "/azp/_work/1/s/majority-com/pages/terms-of-use/[slug].vue?macro=true";
import { default as index1H25RXLpzdMeta } from "/azp/_work/1/s/majority-com/pages/terms-of-use/index.vue?macro=true";
import { default as atmsng1f35Wya3Meta } from "/azp/_work/1/s/majority-com/pages/visa-debit-card/atms.vue?macro=true";
import { default as explore_45discounts8PzlH6xhjHMeta } from "/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/explore-discounts.vue?macro=true";
import { default as indexxKHzoabXRXMeta } from "/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/index.vue?macro=true";
import { default as index3mGdlSOX6BMeta } from "/azp/_work/1/s/majority-com/pages/visa-debit-card/index.vue?macro=true";
import { default as no_45ssn3jiYEmf6bYMeta } from "/azp/_work/1/s/majority-com/pages/visa-debit-card/no-ssn.vue?macro=true";
export default [
  {
    name: _91mtu_93fxicBoiAcbMeta?.name ?? "country-mtu",
    path: _91mtu_93fxicBoiAcbMeta?.path ?? "/:country()/:mtu()",
    meta: _91mtu_93fxicBoiAcbMeta || {},
    alias: _91mtu_93fxicBoiAcbMeta?.alias || [],
    redirect: _91mtu_93fxicBoiAcbMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/[mtu].vue").then(m => m.default || m)
  },
  {
    name: _91mtu_93fxicBoiAcbMeta?.name ?? "country-mtu___en",
    path: _91mtu_93fxicBoiAcbMeta?.path ?? "/en/:country/:mtu",
    meta: _91mtu_93fxicBoiAcbMeta || {},
    alias: _91mtu_93fxicBoiAcbMeta?.alias || [],
    redirect: _91mtu_93fxicBoiAcbMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/[mtu].vue").then(m => m.default || m)
  },
  {
    name: _91mtu_93fxicBoiAcbMeta?.name ?? "country-mtu___es",
    path: _91mtu_93fxicBoiAcbMeta?.path ?? "/es/:country/:mtu",
    meta: _91mtu_93fxicBoiAcbMeta || {},
    alias: _91mtu_93fxicBoiAcbMeta?.alias || [],
    redirect: _91mtu_93fxicBoiAcbMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/[mtu].vue").then(m => m.default || m)
  },
  {
    name: indexFMeeESBMREMeta?.name ?? "country",
    path: indexFMeeESBMREMeta?.path ?? "/:country()",
    meta: indexFMeeESBMREMeta || {},
    alias: indexFMeeESBMREMeta?.alias || [],
    redirect: indexFMeeESBMREMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFMeeESBMREMeta?.name ?? "country___en",
    path: indexFMeeESBMREMeta?.path ?? "/en/:country",
    meta: indexFMeeESBMREMeta || {},
    alias: indexFMeeESBMREMeta?.alias || [],
    redirect: indexFMeeESBMREMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: indexFMeeESBMREMeta?.name ?? "country___es",
    path: indexFMeeESBMREMeta?.path ?? "/es/:country",
    meta: indexFMeeESBMREMeta || {},
    alias: indexFMeeESBMREMeta?.alias || [],
    redirect: indexFMeeESBMREMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: international_45callingWS8XKxWzz7Meta?.name ?? "country-international-calling",
    path: international_45callingWS8XKxWzz7Meta?.path ?? "/:country()/international-calling",
    meta: international_45callingWS8XKxWzz7Meta || {},
    alias: international_45callingWS8XKxWzz7Meta?.alias || [],
    redirect: international_45callingWS8XKxWzz7Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/international-calling.vue").then(m => m.default || m)
  },
  {
    name: international_45callingWS8XKxWzz7Meta?.name ?? "country-international-calling___en",
    path: international_45callingWS8XKxWzz7Meta?.path ?? "/en/:country/international-calling",
    meta: international_45callingWS8XKxWzz7Meta || {},
    alias: international_45callingWS8XKxWzz7Meta?.alias || [],
    redirect: international_45callingWS8XKxWzz7Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/international-calling.vue").then(m => m.default || m)
  },
  {
    name: international_45callingWS8XKxWzz7Meta?.name ?? "country-international-calling___es",
    path: international_45callingWS8XKxWzz7Meta?.path ?? "/es/:country/llamadas-internacionales",
    meta: international_45callingWS8XKxWzz7Meta || {},
    alias: international_45callingWS8XKxWzz7Meta?.alias || [],
    redirect: international_45callingWS8XKxWzz7Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/international-calling.vue").then(m => m.default || m)
  },
  {
    name: majority_45accountB33dCiH7vOMeta?.name ?? "country-majority-account",
    path: majority_45accountB33dCiH7vOMeta?.path ?? "/:country()/majority-account",
    meta: majority_45accountB33dCiH7vOMeta || {},
    alias: majority_45accountB33dCiH7vOMeta?.alias || [],
    redirect: majority_45accountB33dCiH7vOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-account.vue").then(m => m.default || m)
  },
  {
    name: majority_45accountB33dCiH7vOMeta?.name ?? "country-majority-account___en",
    path: majority_45accountB33dCiH7vOMeta?.path ?? "/en/:country/majority-account",
    meta: majority_45accountB33dCiH7vOMeta || {},
    alias: majority_45accountB33dCiH7vOMeta?.alias || [],
    redirect: majority_45accountB33dCiH7vOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-account.vue").then(m => m.default || m)
  },
  {
    name: majority_45accountB33dCiH7vOMeta?.name ?? "country-majority-account___es",
    path: majority_45accountB33dCiH7vOMeta?.path ?? "/es/:country/cuenta-majority",
    meta: majority_45accountB33dCiH7vOMeta || {},
    alias: majority_45accountB33dCiH7vOMeta?.alias || [],
    redirect: majority_45accountB33dCiH7vOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-account.vue").then(m => m.default || m)
  },
  {
    name: majority_45payYa8KahPM1nMeta?.name ?? "country-majority-pay",
    path: majority_45payYa8KahPM1nMeta?.path ?? "/:country()/majority-pay",
    meta: majority_45payYa8KahPM1nMeta || {},
    alias: majority_45payYa8KahPM1nMeta?.alias || [],
    redirect: majority_45payYa8KahPM1nMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-pay.vue").then(m => m.default || m)
  },
  {
    name: majority_45payYa8KahPM1nMeta?.name ?? "country-majority-pay___en",
    path: majority_45payYa8KahPM1nMeta?.path ?? "/en/:country/majority-pay",
    meta: majority_45payYa8KahPM1nMeta || {},
    alias: majority_45payYa8KahPM1nMeta?.alias || [],
    redirect: majority_45payYa8KahPM1nMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-pay.vue").then(m => m.default || m)
  },
  {
    name: majority_45payYa8KahPM1nMeta?.name ?? "country-majority-pay___es",
    path: majority_45payYa8KahPM1nMeta?.path ?? "/es/:country/majority-pay",
    meta: majority_45payYa8KahPM1nMeta || {},
    alias: majority_45payYa8KahPM1nMeta?.alias || [],
    redirect: majority_45payYa8KahPM1nMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/majority-pay.vue").then(m => m.default || m)
  },
  {
    name: money_45transfersIY6PdFMQgZMeta?.name ?? "country-money-transfers",
    path: money_45transfersIY6PdFMQgZMeta?.path ?? "/:country()/money-transfers",
    meta: money_45transfersIY6PdFMQgZMeta || {},
    alias: money_45transfersIY6PdFMQgZMeta?.alias || [],
    redirect: money_45transfersIY6PdFMQgZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/money-transfers.vue").then(m => m.default || m)
  },
  {
    name: money_45transfersIY6PdFMQgZMeta?.name ?? "country-money-transfers___en",
    path: money_45transfersIY6PdFMQgZMeta?.path ?? "/en/:country/money-transfers",
    meta: money_45transfersIY6PdFMQgZMeta || {},
    alias: money_45transfersIY6PdFMQgZMeta?.alias || [],
    redirect: money_45transfersIY6PdFMQgZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/money-transfers.vue").then(m => m.default || m)
  },
  {
    name: money_45transfersIY6PdFMQgZMeta?.name ?? "country-money-transfers___es",
    path: money_45transfersIY6PdFMQgZMeta?.path ?? "/es/:country/envios-dinero",
    meta: money_45transfersIY6PdFMQgZMeta || {},
    alias: money_45transfersIY6PdFMQgZMeta?.alias || [],
    redirect: money_45transfersIY6PdFMQgZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/money-transfers.vue").then(m => m.default || m)
  },
  {
    name: visa_45debit_45cardBqwZJBS391Meta?.name ?? "country-visa-debit-card",
    path: visa_45debit_45cardBqwZJBS391Meta?.path ?? "/:country()/visa-debit-card",
    meta: visa_45debit_45cardBqwZJBS391Meta || {},
    alias: visa_45debit_45cardBqwZJBS391Meta?.alias || [],
    redirect: visa_45debit_45cardBqwZJBS391Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/visa-debit-card.vue").then(m => m.default || m)
  },
  {
    name: visa_45debit_45cardBqwZJBS391Meta?.name ?? "country-visa-debit-card___en",
    path: visa_45debit_45cardBqwZJBS391Meta?.path ?? "/en/:country/visa-debit-card",
    meta: visa_45debit_45cardBqwZJBS391Meta || {},
    alias: visa_45debit_45cardBqwZJBS391Meta?.alias || [],
    redirect: visa_45debit_45cardBqwZJBS391Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/visa-debit-card.vue").then(m => m.default || m)
  },
  {
    name: visa_45debit_45cardBqwZJBS391Meta?.name ?? "country-visa-debit-card___es",
    path: visa_45debit_45cardBqwZJBS391Meta?.path ?? "/es/:country/tarjeta-visa-debito",
    meta: visa_45debit_45cardBqwZJBS391Meta || {},
    alias: visa_45debit_45cardBqwZJBS391Meta?.alias || [],
    redirect: visa_45debit_45cardBqwZJBS391Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/[country]/visa-debit-card.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93fINqKCmuNlMeta?.name ?? "campaign-slug",
    path: _91slug_93fINqKCmuNlMeta?.path ?? "/campaign/:slug()",
    meta: _91slug_93fINqKCmuNlMeta || {},
    alias: _91slug_93fINqKCmuNlMeta?.alias || [],
    redirect: _91slug_93fINqKCmuNlMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93fINqKCmuNlMeta?.name ?? "campaign-slug___en",
    path: _91slug_93fINqKCmuNlMeta?.path ?? "/en/campaign/:slug",
    meta: _91slug_93fINqKCmuNlMeta || {},
    alias: _91slug_93fINqKCmuNlMeta?.alias || [],
    redirect: _91slug_93fINqKCmuNlMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93fINqKCmuNlMeta?.name ?? "campaign-slug___es",
    path: _91slug_93fINqKCmuNlMeta?.path ?? "/es/campana/:slug",
    meta: _91slug_93fINqKCmuNlMeta || {},
    alias: _91slug_93fINqKCmuNlMeta?.alias || [],
    redirect: _91slug_93fINqKCmuNlMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: cuba8edniKWJWZMeta?.name ?? "campaign-cuba",
    path: cuba8edniKWJWZMeta?.path ?? "/campaign/cuba",
    meta: cuba8edniKWJWZMeta || {},
    alias: cuba8edniKWJWZMeta?.alias || [],
    redirect: cuba8edniKWJWZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/cuba.vue").then(m => m.default || m)
  },
  {
    name: cuba8edniKWJWZMeta?.name ?? "campaign-cuba___en",
    path: cuba8edniKWJWZMeta?.path ?? "/en/cuba/save",
    meta: cuba8edniKWJWZMeta || {},
    alias: cuba8edniKWJWZMeta?.alias || [],
    redirect: cuba8edniKWJWZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/cuba.vue").then(m => m.default || m)
  },
  {
    name: cuba8edniKWJWZMeta?.name ?? "campaign-cuba___es",
    path: cuba8edniKWJWZMeta?.path ?? "/es/cuba/ahorrar",
    meta: cuba8edniKWJWZMeta || {},
    alias: cuba8edniKWJWZMeta?.alias || [],
    redirect: cuba8edniKWJWZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/cuba.vue").then(m => m.default || m)
  },
  {
    name: nigeriaUxcOrOzbN5Meta?.name ?? "campaign-nigeria",
    path: nigeriaUxcOrOzbN5Meta?.path ?? "/campaign/nigeria",
    meta: nigeriaUxcOrOzbN5Meta || {},
    alias: nigeriaUxcOrOzbN5Meta?.alias || [],
    redirect: nigeriaUxcOrOzbN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/nigeria.vue").then(m => m.default || m)
  },
  {
    name: nigeriaUxcOrOzbN5Meta?.name ?? "campaign-nigeria___en",
    path: nigeriaUxcOrOzbN5Meta?.path ?? "/en/nigeria/save",
    meta: nigeriaUxcOrOzbN5Meta || {},
    alias: nigeriaUxcOrOzbN5Meta?.alias || [],
    redirect: nigeriaUxcOrOzbN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/nigeria.vue").then(m => m.default || m)
  },
  {
    name: nigeriaUxcOrOzbN5Meta?.name ?? "campaign-nigeria___es",
    path: nigeriaUxcOrOzbN5Meta?.path ?? "/es/nigeria/ahorrar",
    meta: nigeriaUxcOrOzbN5Meta || {},
    alias: nigeriaUxcOrOzbN5Meta?.alias || [],
    redirect: nigeriaUxcOrOzbN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/campaign/nigeria.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93kHxohGOg5lMeta?.name ?? "community-slug",
    path: _91slug_93kHxohGOg5lMeta?.path ?? "/community/:slug()",
    meta: _91slug_93kHxohGOg5lMeta || {},
    alias: _91slug_93kHxohGOg5lMeta?.alias || [],
    redirect: _91slug_93kHxohGOg5lMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93kHxohGOg5lMeta?.name ?? "community-slug___en",
    path: _91slug_93kHxohGOg5lMeta?.path ?? "/en/community/:slug",
    meta: _91slug_93kHxohGOg5lMeta || {},
    alias: _91slug_93kHxohGOg5lMeta?.alias || [],
    redirect: _91slug_93kHxohGOg5lMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93kHxohGOg5lMeta?.name ?? "community-slug___es",
    path: _91slug_93kHxohGOg5lMeta?.path ?? "/es/comunidad/:slug",
    meta: _91slug_93kHxohGOg5lMeta || {},
    alias: _91slug_93kHxohGOg5lMeta?.alias || [],
    redirect: _91slug_93kHxohGOg5lMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93jKHv5TAB8EMeta?.name ?? "community-article-slug",
    path: _91slug_93jKHv5TAB8EMeta?.path ?? "/community/article/:slug()",
    meta: _91slug_93jKHv5TAB8EMeta || {},
    alias: _91slug_93jKHv5TAB8EMeta?.alias || [],
    redirect: _91slug_93jKHv5TAB8EMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93jKHv5TAB8EMeta?.name ?? "community-article-slug___en",
    path: _91slug_93jKHv5TAB8EMeta?.path ?? "/en/community/article/:slug",
    meta: _91slug_93jKHv5TAB8EMeta || {},
    alias: _91slug_93jKHv5TAB8EMeta?.alias || [],
    redirect: _91slug_93jKHv5TAB8EMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93jKHv5TAB8EMeta?.name ?? "community-article-slug___es",
    path: _91slug_93jKHv5TAB8EMeta?.path ?? "/es/comunidad/article/:slug",
    meta: _91slug_93jKHv5TAB8EMeta || {},
    alias: _91slug_93jKHv5TAB8EMeta?.alias || [],
    redirect: _91slug_93jKHv5TAB8EMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93iIfGaqphoNMeta?.name ?? "community-discount-slug",
    path: _91slug_93iIfGaqphoNMeta?.path ?? "/community/discount/:slug()",
    meta: _91slug_93iIfGaqphoNMeta || {},
    alias: _91slug_93iIfGaqphoNMeta?.alias || [],
    redirect: _91slug_93iIfGaqphoNMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/discount/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93iIfGaqphoNMeta?.name ?? "community-discount-slug___en",
    path: _91slug_93iIfGaqphoNMeta?.path ?? "/en/community/discount/:slug",
    meta: _91slug_93iIfGaqphoNMeta || {},
    alias: _91slug_93iIfGaqphoNMeta?.alias || [],
    redirect: _91slug_93iIfGaqphoNMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/discount/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93iIfGaqphoNMeta?.name ?? "community-discount-slug___es",
    path: _91slug_93iIfGaqphoNMeta?.path ?? "/es/comunidad/descuento/:slug",
    meta: _91slug_93iIfGaqphoNMeta || {},
    alias: _91slug_93iIfGaqphoNMeta?.alias || [],
    redirect: _91slug_93iIfGaqphoNMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/discount/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93LqbBBI3vCPMeta?.name ?? "community-event-slug",
    path: _91slug_93LqbBBI3vCPMeta?.path ?? "/community/event/:slug()",
    meta: _91slug_93LqbBBI3vCPMeta || {},
    alias: _91slug_93LqbBBI3vCPMeta?.alias || [],
    redirect: _91slug_93LqbBBI3vCPMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93LqbBBI3vCPMeta?.name ?? "community-event-slug___en",
    path: _91slug_93LqbBBI3vCPMeta?.path ?? "/en/community/event/:slug",
    meta: _91slug_93LqbBBI3vCPMeta || {},
    alias: _91slug_93LqbBBI3vCPMeta?.alias || [],
    redirect: _91slug_93LqbBBI3vCPMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93LqbBBI3vCPMeta?.name ?? "community-event-slug___es",
    path: _91slug_93LqbBBI3vCPMeta?.path ?? "/es/comunidad/evento/:slug",
    meta: _91slug_93LqbBBI3vCPMeta || {},
    alias: _91slug_93LqbBBI3vCPMeta?.alias || [],
    redirect: _91slug_93LqbBBI3vCPMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/event/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexnG7smlq6kVMeta?.name ?? "community",
    path: indexnG7smlq6kVMeta?.path ?? "/community",
    meta: indexnG7smlq6kVMeta || {},
    alias: indexnG7smlq6kVMeta?.alias || [],
    redirect: indexnG7smlq6kVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/index.vue").then(m => m.default || m)
  },
  {
    name: indexnG7smlq6kVMeta?.name ?? "community___en",
    path: indexnG7smlq6kVMeta?.path ?? "/en/community",
    meta: indexnG7smlq6kVMeta || {},
    alias: indexnG7smlq6kVMeta?.alias || [],
    redirect: indexnG7smlq6kVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/index.vue").then(m => m.default || m)
  },
  {
    name: indexnG7smlq6kVMeta?.name ?? "community___es",
    path: indexnG7smlq6kVMeta?.path ?? "/es/comunidad",
    meta: indexnG7smlq6kVMeta || {},
    alias: indexnG7smlq6kVMeta?.alias || [],
    redirect: indexnG7smlq6kVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93w9AuihdNk1Meta?.name ?? "community-majority-tv-slug",
    path: _91slug_93w9AuihdNk1Meta?.path ?? "/community/majority-tv/:slug()",
    meta: _91slug_93w9AuihdNk1Meta || {},
    alias: _91slug_93w9AuihdNk1Meta?.alias || [],
    redirect: _91slug_93w9AuihdNk1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/majority-tv/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93w9AuihdNk1Meta?.name ?? "community-majority-tv-slug___en",
    path: _91slug_93w9AuihdNk1Meta?.path ?? "/en/community/majority-tv/:slug",
    meta: _91slug_93w9AuihdNk1Meta || {},
    alias: _91slug_93w9AuihdNk1Meta?.alias || [],
    redirect: _91slug_93w9AuihdNk1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/majority-tv/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93w9AuihdNk1Meta?.name ?? "community-majority-tv-slug___es",
    path: _91slug_93w9AuihdNk1Meta?.path ?? "/es/comunidad/majority-tv/:slug",
    meta: _91slug_93w9AuihdNk1Meta || {},
    alias: _91slug_93w9AuihdNk1Meta?.alias || [],
    redirect: _91slug_93w9AuihdNk1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/majority-tv/[slug].vue").then(m => m.default || m)
  },
  {
    name: migrant_45handbookKMhbjLMhEpMeta?.name ?? "community-migrant-handbook",
    path: migrant_45handbookKMhbjLMhEpMeta?.path ?? "/community/migrant-handbook",
    meta: migrant_45handbookKMhbjLMhEpMeta || {},
    alias: migrant_45handbookKMhbjLMhEpMeta?.alias || [],
    redirect: migrant_45handbookKMhbjLMhEpMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/migrant-handbook.vue").then(m => m.default || m)
  },
  {
    name: migrant_45handbookKMhbjLMhEpMeta?.name ?? "community-migrant-handbook___en",
    path: migrant_45handbookKMhbjLMhEpMeta?.path ?? "/en/community/migrant-handbook",
    meta: migrant_45handbookKMhbjLMhEpMeta || {},
    alias: migrant_45handbookKMhbjLMhEpMeta?.alias || [],
    redirect: migrant_45handbookKMhbjLMhEpMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/migrant-handbook.vue").then(m => m.default || m)
  },
  {
    name: migrant_45handbookKMhbjLMhEpMeta?.name ?? "community-migrant-handbook___es",
    path: migrant_45handbookKMhbjLMhEpMeta?.path ?? "/es/comunidad/guia-migrante",
    meta: migrant_45handbookKMhbjLMhEpMeta || {},
    alias: migrant_45handbookKMhbjLMhEpMeta?.alias || [],
    redirect: migrant_45handbookKMhbjLMhEpMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/migrant-handbook.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cCPN872hGiMeta?.name ?? "community-tag-slug",
    path: _91slug_93cCPN872hGiMeta?.path ?? "/community/tag/:slug()",
    meta: _91slug_93cCPN872hGiMeta || {},
    alias: _91slug_93cCPN872hGiMeta?.alias || [],
    redirect: _91slug_93cCPN872hGiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cCPN872hGiMeta?.name ?? "community-tag-slug___en",
    path: _91slug_93cCPN872hGiMeta?.path ?? "/en/community/tag/:slug",
    meta: _91slug_93cCPN872hGiMeta || {},
    alias: _91slug_93cCPN872hGiMeta?.alias || [],
    redirect: _91slug_93cCPN872hGiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93cCPN872hGiMeta?.name ?? "community-tag-slug___es",
    path: _91slug_93cCPN872hGiMeta?.path ?? "/es/comunidad/tag/:slug",
    meta: _91slug_93cCPN872hGiMeta || {},
    alias: _91slug_93cCPN872hGiMeta?.alias || [],
    redirect: _91slug_93cCPN872hGiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/community/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: applySGVcLNWVuJMeta?.name ?? "company-career-apply",
    path: applySGVcLNWVuJMeta?.path ?? "/company/career/apply",
    meta: applySGVcLNWVuJMeta || {},
    alias: applySGVcLNWVuJMeta?.alias || [],
    redirect: applySGVcLNWVuJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/apply.vue").then(m => m.default || m)
  },
  {
    name: applySGVcLNWVuJMeta?.name ?? "company-career-apply___en",
    path: applySGVcLNWVuJMeta?.path ?? "/en/company/career/apply",
    meta: applySGVcLNWVuJMeta || {},
    alias: applySGVcLNWVuJMeta?.alias || [],
    redirect: applySGVcLNWVuJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/apply.vue").then(m => m.default || m)
  },
  {
    name: applySGVcLNWVuJMeta?.name ?? "company-career-apply___es",
    path: applySGVcLNWVuJMeta?.path ?? "/es/empresa/bolsa-trabajo/aplicar",
    meta: applySGVcLNWVuJMeta || {},
    alias: applySGVcLNWVuJMeta?.alias || [],
    redirect: applySGVcLNWVuJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/apply.vue").then(m => m.default || m)
  },
  {
    name: indexWCwmj7dINQMeta?.name ?? "company-career",
    path: indexWCwmj7dINQMeta?.path ?? "/company/career",
    meta: indexWCwmj7dINQMeta || {},
    alias: indexWCwmj7dINQMeta?.alias || [],
    redirect: indexWCwmj7dINQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/index.vue").then(m => m.default || m)
  },
  {
    name: indexWCwmj7dINQMeta?.name ?? "company-career___en",
    path: indexWCwmj7dINQMeta?.path ?? "/en/company/career",
    meta: indexWCwmj7dINQMeta || {},
    alias: indexWCwmj7dINQMeta?.alias || [],
    redirect: indexWCwmj7dINQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/index.vue").then(m => m.default || m)
  },
  {
    name: indexWCwmj7dINQMeta?.name ?? "company-career___es",
    path: indexWCwmj7dINQMeta?.path ?? "/es/empresa/bolsa-trabajo",
    meta: indexWCwmj7dINQMeta || {},
    alias: indexWCwmj7dINQMeta?.alias || [],
    redirect: indexWCwmj7dINQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Ojf2gG21BQMeta?.name ?? "company-career-position-slug",
    path: _91slug_93Ojf2gG21BQMeta?.path ?? "/company/career/position/:slug()",
    meta: _91slug_93Ojf2gG21BQMeta || {},
    alias: _91slug_93Ojf2gG21BQMeta?.alias || [],
    redirect: _91slug_93Ojf2gG21BQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/position/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Ojf2gG21BQMeta?.name ?? "company-career-position-slug___en",
    path: _91slug_93Ojf2gG21BQMeta?.path ?? "/en/company/career/position/:slug",
    meta: _91slug_93Ojf2gG21BQMeta || {},
    alias: _91slug_93Ojf2gG21BQMeta?.alias || [],
    redirect: _91slug_93Ojf2gG21BQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/position/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Ojf2gG21BQMeta?.name ?? "company-career-position-slug___es",
    path: _91slug_93Ojf2gG21BQMeta?.path ?? "/es/empresa/bolsa-trabajo/puestos-disponibles/:slug",
    meta: _91slug_93Ojf2gG21BQMeta || {},
    alias: _91slug_93Ojf2gG21BQMeta?.alias || [],
    redirect: _91slug_93Ojf2gG21BQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/career/position/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexNV1P6mUC8JMeta?.name ?? "company",
    path: indexNV1P6mUC8JMeta?.path ?? "/company",
    meta: indexNV1P6mUC8JMeta || {},
    alias: indexNV1P6mUC8JMeta?.alias || [],
    redirect: indexNV1P6mUC8JMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/index.vue").then(m => m.default || m)
  },
  {
    name: indexNV1P6mUC8JMeta?.name ?? "company___en",
    path: indexNV1P6mUC8JMeta?.path ?? "/en/company",
    meta: indexNV1P6mUC8JMeta || {},
    alias: indexNV1P6mUC8JMeta?.alias || [],
    redirect: indexNV1P6mUC8JMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/index.vue").then(m => m.default || m)
  },
  {
    name: indexNV1P6mUC8JMeta?.name ?? "company___es",
    path: indexNV1P6mUC8JMeta?.path ?? "/es/empresa",
    meta: indexNV1P6mUC8JMeta || {},
    alias: indexNV1P6mUC8JMeta?.alias || [],
    redirect: indexNV1P6mUC8JMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/company/index.vue").then(m => m.default || m)
  },
  {
    name: indexBloo3FVsqVMeta?.name ?? "data-deletion",
    path: indexBloo3FVsqVMeta?.path ?? "/data-deletion",
    meta: indexBloo3FVsqVMeta || {},
    alias: indexBloo3FVsqVMeta?.alias || [],
    redirect: indexBloo3FVsqVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/data-deletion/index.vue").then(m => m.default || m)
  },
  {
    name: indexBloo3FVsqVMeta?.name ?? "data-deletion___en",
    path: indexBloo3FVsqVMeta?.path ?? "/en/data-deletion",
    meta: indexBloo3FVsqVMeta || {},
    alias: indexBloo3FVsqVMeta?.alias || [],
    redirect: indexBloo3FVsqVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/data-deletion/index.vue").then(m => m.default || m)
  },
  {
    name: indexBloo3FVsqVMeta?.name ?? "data-deletion___es",
    path: indexBloo3FVsqVMeta?.path ?? "/es/eliminacion-de-datos",
    meta: indexBloo3FVsqVMeta || {},
    alias: indexBloo3FVsqVMeta?.alias || [],
    redirect: indexBloo3FVsqVMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/data-deletion/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_939zMMbAiMXZMeta?.name ?? "help-article-slug",
    path: _91slug_939zMMbAiMXZMeta?.path ?? "/help/article/:slug()",
    meta: _91slug_939zMMbAiMXZMeta || {},
    alias: _91slug_939zMMbAiMXZMeta?.alias || [],
    redirect: _91slug_939zMMbAiMXZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_939zMMbAiMXZMeta?.name ?? "help-article-slug___en",
    path: _91slug_939zMMbAiMXZMeta?.path ?? "/en/help/article/:slug",
    meta: _91slug_939zMMbAiMXZMeta || {},
    alias: _91slug_939zMMbAiMXZMeta?.alias || [],
    redirect: _91slug_939zMMbAiMXZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_939zMMbAiMXZMeta?.name ?? "help-article-slug___es",
    path: _91slug_939zMMbAiMXZMeta?.path ?? "/es/ayuda/article/:slug",
    meta: _91slug_939zMMbAiMXZMeta || {},
    alias: _91slug_939zMMbAiMXZMeta?.alias || [],
    redirect: _91slug_939zMMbAiMXZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91subcategory_93KcvZMZQsqwMeta?.name ?? "help-category-slug-subcategory",
    path: _91subcategory_93KcvZMZQsqwMeta?.path ?? "/help/category/:slug()/:subcategory()",
    meta: _91subcategory_93KcvZMZQsqwMeta || {},
    alias: _91subcategory_93KcvZMZQsqwMeta?.alias || [],
    redirect: _91subcategory_93KcvZMZQsqwMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/[subcategory].vue").then(m => m.default || m)
  },
  {
    name: _91subcategory_93KcvZMZQsqwMeta?.name ?? "help-category-slug-subcategory___en",
    path: _91subcategory_93KcvZMZQsqwMeta?.path ?? "/en/help/category/:slug/:subcategory",
    meta: _91subcategory_93KcvZMZQsqwMeta || {},
    alias: _91subcategory_93KcvZMZQsqwMeta?.alias || [],
    redirect: _91subcategory_93KcvZMZQsqwMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/[subcategory].vue").then(m => m.default || m)
  },
  {
    name: _91subcategory_93KcvZMZQsqwMeta?.name ?? "help-category-slug-subcategory___es",
    path: _91subcategory_93KcvZMZQsqwMeta?.path ?? "/es/ayuda/categoria/:slug/:subcategory",
    meta: _91subcategory_93KcvZMZQsqwMeta || {},
    alias: _91subcategory_93KcvZMZQsqwMeta?.alias || [],
    redirect: _91subcategory_93KcvZMZQsqwMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/[subcategory].vue").then(m => m.default || m)
  },
  {
    name: indexKJveditLSuMeta?.name ?? "help-category-slug",
    path: indexKJveditLSuMeta?.path ?? "/help/category/:slug()",
    meta: indexKJveditLSuMeta || {},
    alias: indexKJveditLSuMeta?.alias || [],
    redirect: indexKJveditLSuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexKJveditLSuMeta?.name ?? "help-category-slug___en",
    path: indexKJveditLSuMeta?.path ?? "/en/help/category/:slug",
    meta: indexKJveditLSuMeta || {},
    alias: indexKJveditLSuMeta?.alias || [],
    redirect: indexKJveditLSuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexKJveditLSuMeta?.name ?? "help-category-slug___es",
    path: indexKJveditLSuMeta?.path ?? "/es/ayuda/categoria/:slug",
    meta: indexKJveditLSuMeta || {},
    alias: indexKJveditLSuMeta?.alias || [],
    redirect: indexKJveditLSuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/category/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexjyFB3DGcTWMeta?.name ?? "help",
    path: indexjyFB3DGcTWMeta?.path ?? "/help",
    meta: indexjyFB3DGcTWMeta || {},
    alias: indexjyFB3DGcTWMeta?.alias || [],
    redirect: indexjyFB3DGcTWMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: indexjyFB3DGcTWMeta?.name ?? "help___en",
    path: indexjyFB3DGcTWMeta?.path ?? "/en/help",
    meta: indexjyFB3DGcTWMeta || {},
    alias: indexjyFB3DGcTWMeta?.alias || [],
    redirect: indexjyFB3DGcTWMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: indexjyFB3DGcTWMeta?.name ?? "help___es",
    path: indexjyFB3DGcTWMeta?.path ?? "/es/ayuda",
    meta: indexjyFB3DGcTWMeta || {},
    alias: indexjyFB3DGcTWMeta?.alias || [],
    redirect: indexjyFB3DGcTWMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/index.vue").then(m => m.default || m)
  },
  {
    name: searchsSSJdtOaf4Meta?.name ?? "help-search",
    path: searchsSSJdtOaf4Meta?.path ?? "/help/search",
    meta: searchsSSJdtOaf4Meta || {},
    alias: searchsSSJdtOaf4Meta?.alias || [],
    redirect: searchsSSJdtOaf4Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/search.vue").then(m => m.default || m)
  },
  {
    name: searchsSSJdtOaf4Meta?.name ?? "help-search___en",
    path: searchsSSJdtOaf4Meta?.path ?? "/en/help/search",
    meta: searchsSSJdtOaf4Meta || {},
    alias: searchsSSJdtOaf4Meta?.alias || [],
    redirect: searchsSSJdtOaf4Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/search.vue").then(m => m.default || m)
  },
  {
    name: searchsSSJdtOaf4Meta?.name ?? "help-search___es",
    path: searchsSSJdtOaf4Meta?.path ?? "/es/ayuda/search",
    meta: searchsSSJdtOaf4Meta || {},
    alias: searchsSSJdtOaf4Meta?.alias || [],
    redirect: searchsSSJdtOaf4Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/help/search.vue").then(m => m.default || m)
  },
  {
    name: indexSr6B4p1L8rMeta?.name ?? "index",
    path: indexSr6B4p1L8rMeta?.path ?? "/",
    meta: indexSr6B4p1L8rMeta || {},
    alias: indexSr6B4p1L8rMeta?.alias || [],
    redirect: indexSr6B4p1L8rMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexSr6B4p1L8rMeta?.name ?? "index___en",
    path: indexSr6B4p1L8rMeta?.path ?? "/en",
    meta: indexSr6B4p1L8rMeta || {},
    alias: indexSr6B4p1L8rMeta?.alias || [],
    redirect: indexSr6B4p1L8rMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexSr6B4p1L8rMeta?.name ?? "index___es",
    path: indexSr6B4p1L8rMeta?.path ?? "/es",
    meta: indexSr6B4p1L8rMeta || {},
    alias: indexSr6B4p1L8rMeta?.alias || [],
    redirect: indexSr6B4p1L8rMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ibzcqqyNeZMeta?.name ?? "internal-library-slug",
    path: _91slug_93ibzcqqyNeZMeta?.path ?? "/internal/library/:slug()",
    meta: _91slug_93ibzcqqyNeZMeta || {},
    alias: _91slug_93ibzcqqyNeZMeta?.alias || [],
    redirect: _91slug_93ibzcqqyNeZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ibzcqqyNeZMeta?.name ?? "internal-library-slug___en",
    path: _91slug_93ibzcqqyNeZMeta?.path ?? "/en/internal/library/:slug()",
    meta: _91slug_93ibzcqqyNeZMeta || {},
    alias: _91slug_93ibzcqqyNeZMeta?.alias || [],
    redirect: _91slug_93ibzcqqyNeZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93ibzcqqyNeZMeta?.name ?? "internal-library-slug___es",
    path: _91slug_93ibzcqqyNeZMeta?.path ?? "/es/internal/library/:slug()",
    meta: _91slug_93ibzcqqyNeZMeta || {},
    alias: _91slug_93ibzcqqyNeZMeta?.alias || [],
    redirect: _91slug_93ibzcqqyNeZMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91country_93ILZOLPCEN1Meta?.name ?? "internal-library-money-transfers-country",
    path: _91country_93ILZOLPCEN1Meta?.path ?? "/internal/library/money-transfers/:country()",
    meta: _91country_93ILZOLPCEN1Meta || {},
    alias: _91country_93ILZOLPCEN1Meta?.alias || [],
    redirect: _91country_93ILZOLPCEN1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/[country].vue").then(m => m.default || m)
  },
  {
    name: _91country_93ILZOLPCEN1Meta?.name ?? "internal-library-money-transfers-country___en",
    path: _91country_93ILZOLPCEN1Meta?.path ?? "/en/internal/library/money-transfers/:country()",
    meta: _91country_93ILZOLPCEN1Meta || {},
    alias: _91country_93ILZOLPCEN1Meta?.alias || [],
    redirect: _91country_93ILZOLPCEN1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/[country].vue").then(m => m.default || m)
  },
  {
    name: _91country_93ILZOLPCEN1Meta?.name ?? "internal-library-money-transfers-country___es",
    path: _91country_93ILZOLPCEN1Meta?.path ?? "/es/internal/library/money-transfers/:country()",
    meta: _91country_93ILZOLPCEN1Meta || {},
    alias: _91country_93ILZOLPCEN1Meta?.alias || [],
    redirect: _91country_93ILZOLPCEN1Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/[country].vue").then(m => m.default || m)
  },
  {
    name: indexYQAkQFdmdfMeta?.name ?? "internal-library-money-transfers",
    path: indexYQAkQFdmdfMeta?.path ?? "/internal/library/money-transfers",
    meta: indexYQAkQFdmdfMeta || {},
    alias: indexYQAkQFdmdfMeta?.alias || [],
    redirect: indexYQAkQFdmdfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: indexYQAkQFdmdfMeta?.name ?? "internal-library-money-transfers___en",
    path: indexYQAkQFdmdfMeta?.path ?? "/en/internal/library/money-transfers",
    meta: indexYQAkQFdmdfMeta || {},
    alias: indexYQAkQFdmdfMeta?.alias || [],
    redirect: indexYQAkQFdmdfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: indexYQAkQFdmdfMeta?.name ?? "internal-library-money-transfers___es",
    path: indexYQAkQFdmdfMeta?.path ?? "/es/internal/library/money-transfers",
    meta: indexYQAkQFdmdfMeta || {},
    alias: indexYQAkQFdmdfMeta?.alias || [],
    redirect: indexYQAkQFdmdfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/library/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: submit_45tickettSSQNvkTlQMeta?.name ?? "internal-submit-ticket",
    path: submit_45tickettSSQNvkTlQMeta?.path ?? "/internal/submit-ticket",
    meta: submit_45tickettSSQNvkTlQMeta || {},
    alias: submit_45tickettSSQNvkTlQMeta?.alias || [],
    redirect: submit_45tickettSSQNvkTlQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/submit-ticket.vue").then(m => m.default || m)
  },
  {
    name: submit_45tickettSSQNvkTlQMeta?.name ?? "internal-submit-ticket___en",
    path: submit_45tickettSSQNvkTlQMeta?.path ?? "/en/internal/submit-ticket",
    meta: submit_45tickettSSQNvkTlQMeta || {},
    alias: submit_45tickettSSQNvkTlQMeta?.alias || [],
    redirect: submit_45tickettSSQNvkTlQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/submit-ticket.vue").then(m => m.default || m)
  },
  {
    name: submit_45tickettSSQNvkTlQMeta?.name ?? "internal-submit-ticket___es",
    path: submit_45tickettSSQNvkTlQMeta?.path ?? "/es/internal/enviar-ticket",
    meta: submit_45tickettSSQNvkTlQMeta || {},
    alias: submit_45tickettSSQNvkTlQMeta?.alias || [],
    redirect: submit_45tickettSSQNvkTlQMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/submit-ticket.vue").then(m => m.default || m)
  },
  {
    name: verify_45email5htISovhS0Meta?.name ?? "internal-verify-email",
    path: verify_45email5htISovhS0Meta?.path ?? "/internal/verify-email",
    meta: verify_45email5htISovhS0Meta || {},
    alias: verify_45email5htISovhS0Meta?.alias || [],
    redirect: verify_45email5htISovhS0Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45email5htISovhS0Meta?.name ?? "internal-verify-email___en",
    path: verify_45email5htISovhS0Meta?.path ?? "/en/internal/verify-email",
    meta: verify_45email5htISovhS0Meta || {},
    alias: verify_45email5htISovhS0Meta?.alias || [],
    redirect: verify_45email5htISovhS0Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/verify-email.vue").then(m => m.default || m)
  },
  {
    name: verify_45email5htISovhS0Meta?.name ?? "internal-verify-email___es",
    path: verify_45email5htISovhS0Meta?.path ?? "/es/internal/verify-email",
    meta: verify_45email5htISovhS0Meta || {},
    alias: verify_45email5htISovhS0Meta?.alias || [],
    redirect: verify_45email5htISovhS0Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/internal/verify-email.vue").then(m => m.default || m)
  },
  {
    name: calling_45ratesYO6pSj65G5Meta?.name ?? "international-calling-calling-rates",
    path: calling_45ratesYO6pSj65G5Meta?.path ?? "/international-calling/calling-rates",
    meta: calling_45ratesYO6pSj65G5Meta || {},
    alias: calling_45ratesYO6pSj65G5Meta?.alias || [],
    redirect: calling_45ratesYO6pSj65G5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/calling-rates.vue").then(m => m.default || m)
  },
  {
    name: calling_45ratesYO6pSj65G5Meta?.name ?? "international-calling-calling-rates___en",
    path: calling_45ratesYO6pSj65G5Meta?.path ?? "/en/international-calling/calling-rates",
    meta: calling_45ratesYO6pSj65G5Meta || {},
    alias: calling_45ratesYO6pSj65G5Meta?.alias || [],
    redirect: calling_45ratesYO6pSj65G5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/calling-rates.vue").then(m => m.default || m)
  },
  {
    name: calling_45ratesYO6pSj65G5Meta?.name ?? "international-calling-calling-rates___es",
    path: calling_45ratesYO6pSj65G5Meta?.path ?? "/es/llamadas-internacionales/tarifas-llamadas",
    meta: calling_45ratesYO6pSj65G5Meta || {},
    alias: calling_45ratesYO6pSj65G5Meta?.alias || [],
    redirect: calling_45ratesYO6pSj65G5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/calling-rates.vue").then(m => m.default || m)
  },
  {
    name: indexWA6BnUyzN5Meta?.name ?? "international-calling",
    path: indexWA6BnUyzN5Meta?.path ?? "/international-calling",
    meta: indexWA6BnUyzN5Meta || {},
    alias: indexWA6BnUyzN5Meta?.alias || [],
    redirect: indexWA6BnUyzN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/index.vue").then(m => m.default || m)
  },
  {
    name: indexWA6BnUyzN5Meta?.name ?? "international-calling___en",
    path: indexWA6BnUyzN5Meta?.path ?? "/en/international-calling",
    meta: indexWA6BnUyzN5Meta || {},
    alias: indexWA6BnUyzN5Meta?.alias || [],
    redirect: indexWA6BnUyzN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/index.vue").then(m => m.default || m)
  },
  {
    name: indexWA6BnUyzN5Meta?.name ?? "international-calling___es",
    path: indexWA6BnUyzN5Meta?.path ?? "/es/llamadas-internacionales",
    meta: indexWA6BnUyzN5Meta || {},
    alias: indexWA6BnUyzN5Meta?.alias || [],
    redirect: indexWA6BnUyzN5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/index.vue").then(m => m.default || m)
  },
  {
    name: unlimitedTarH0uC4RyMeta?.name ?? "international-calling-unlimited",
    path: unlimitedTarH0uC4RyMeta?.path ?? "/international-calling/unlimited",
    meta: unlimitedTarH0uC4RyMeta || {},
    alias: unlimitedTarH0uC4RyMeta?.alias || [],
    redirect: unlimitedTarH0uC4RyMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/unlimited.vue").then(m => m.default || m)
  },
  {
    name: unlimitedTarH0uC4RyMeta?.name ?? "international-calling-unlimited___en",
    path: unlimitedTarH0uC4RyMeta?.path ?? "/en/international-calling/unlimited",
    meta: unlimitedTarH0uC4RyMeta || {},
    alias: unlimitedTarH0uC4RyMeta?.alias || [],
    redirect: unlimitedTarH0uC4RyMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/unlimited.vue").then(m => m.default || m)
  },
  {
    name: unlimitedTarH0uC4RyMeta?.name ?? "international-calling-unlimited___es",
    path: unlimitedTarH0uC4RyMeta?.path ?? "/es/llamadas-internacionales/ilimitadas",
    meta: unlimitedTarH0uC4RyMeta || {},
    alias: unlimitedTarH0uC4RyMeta?.alias || [],
    redirect: unlimitedTarH0uC4RyMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/international-calling/unlimited.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityBWmiPTAFC2Meta?.name ?? "legal-privacy-policy-team-majority",
    path: team_45majorityBWmiPTAFC2Meta?.path ?? "/legal/privacy-policy/team-majority",
    meta: team_45majorityBWmiPTAFC2Meta || {},
    alias: team_45majorityBWmiPTAFC2Meta?.alias || [],
    redirect: team_45majorityBWmiPTAFC2Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityBWmiPTAFC2Meta?.name ?? "legal-privacy-policy-team-majority___en",
    path: team_45majorityBWmiPTAFC2Meta?.path ?? "/en/legal/privacy-policy/team-majority",
    meta: team_45majorityBWmiPTAFC2Meta || {},
    alias: team_45majorityBWmiPTAFC2Meta?.alias || [],
    redirect: team_45majorityBWmiPTAFC2Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityBWmiPTAFC2Meta?.name ?? "legal-privacy-policy-team-majority___es",
    path: team_45majorityBWmiPTAFC2Meta?.path ?? "/es/legal/privacy-policy/team-majority",
    meta: team_45majorityBWmiPTAFC2Meta || {},
    alias: team_45majorityBWmiPTAFC2Meta?.alias || [],
    redirect: team_45majorityBWmiPTAFC2Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityJU7Fins4iiMeta?.name ?? "legal-terms-and-conditions-team-majority",
    path: team_45majorityJU7Fins4iiMeta?.path ?? "/legal/terms-and-conditions/team-majority",
    meta: team_45majorityJU7Fins4iiMeta || {},
    alias: team_45majorityJU7Fins4iiMeta?.alias || [],
    redirect: team_45majorityJU7Fins4iiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityJU7Fins4iiMeta?.name ?? "legal-terms-and-conditions-team-majority___en",
    path: team_45majorityJU7Fins4iiMeta?.path ?? "/en/legal/terms-and-conditions/team-majority",
    meta: team_45majorityJU7Fins4iiMeta || {},
    alias: team_45majorityJU7Fins4iiMeta?.alias || [],
    redirect: team_45majorityJU7Fins4iiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityJU7Fins4iiMeta?.name ?? "legal-terms-and-conditions-team-majority___es",
    path: team_45majorityJU7Fins4iiMeta?.path ?? "/es/legal/terms-and-conditions/team-majority",
    meta: team_45majorityJU7Fins4iiMeta || {},
    alias: team_45majorityJU7Fins4iiMeta?.alias || [],
    redirect: team_45majorityJU7Fins4iiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/legal/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: indexrWut2IKrUiMeta?.name ?? "locations",
    path: indexrWut2IKrUiMeta?.path ?? "/locations",
    meta: indexrWut2IKrUiMeta || {},
    alias: indexrWut2IKrUiMeta?.alias || [],
    redirect: indexrWut2IKrUiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/locations/index.vue").then(m => m.default || m)
  },
  {
    name: indexrWut2IKrUiMeta?.name ?? "locations___en",
    path: indexrWut2IKrUiMeta?.path ?? "/en/locations",
    meta: indexrWut2IKrUiMeta || {},
    alias: indexrWut2IKrUiMeta?.alias || [],
    redirect: indexrWut2IKrUiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/locations/index.vue").then(m => m.default || m)
  },
  {
    name: indexrWut2IKrUiMeta?.name ?? "locations___es",
    path: indexrWut2IKrUiMeta?.path ?? "/es/ubicaciones",
    meta: indexrWut2IKrUiMeta || {},
    alias: indexrWut2IKrUiMeta?.alias || [],
    redirect: indexrWut2IKrUiMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/locations/index.vue").then(m => m.default || m)
  },
  {
    name: get_45paid_45earlyWnUDYQsEUrMeta?.name ?? "majority-account-get-paid-early",
    path: get_45paid_45earlyWnUDYQsEUrMeta?.path ?? "/majority-account/get-paid-early",
    meta: get_45paid_45earlyWnUDYQsEUrMeta || {},
    alias: get_45paid_45earlyWnUDYQsEUrMeta?.alias || [],
    redirect: get_45paid_45earlyWnUDYQsEUrMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/get-paid-early.vue").then(m => m.default || m)
  },
  {
    name: get_45paid_45earlyWnUDYQsEUrMeta?.name ?? "majority-account-get-paid-early___en",
    path: get_45paid_45earlyWnUDYQsEUrMeta?.path ?? "/en/majority-account/get-paid-early",
    meta: get_45paid_45earlyWnUDYQsEUrMeta || {},
    alias: get_45paid_45earlyWnUDYQsEUrMeta?.alias || [],
    redirect: get_45paid_45earlyWnUDYQsEUrMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/get-paid-early.vue").then(m => m.default || m)
  },
  {
    name: get_45paid_45earlyWnUDYQsEUrMeta?.name ?? "majority-account-get-paid-early___es",
    path: get_45paid_45earlyWnUDYQsEUrMeta?.path ?? "/es/cuenta-majority/recibir-sueldo-antes",
    meta: get_45paid_45earlyWnUDYQsEUrMeta || {},
    alias: get_45paid_45earlyWnUDYQsEUrMeta?.alias || [],
    redirect: get_45paid_45earlyWnUDYQsEUrMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/get-paid-early.vue").then(m => m.default || m)
  },
  {
    name: indexfILmjjvnkOMeta?.name ?? "majority-account",
    path: indexfILmjjvnkOMeta?.path ?? "/majority-account",
    meta: indexfILmjjvnkOMeta || {},
    alias: indexfILmjjvnkOMeta?.alias || [],
    redirect: indexfILmjjvnkOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/index.vue").then(m => m.default || m)
  },
  {
    name: indexfILmjjvnkOMeta?.name ?? "majority-account___en",
    path: indexfILmjjvnkOMeta?.path ?? "/en/majority-account",
    meta: indexfILmjjvnkOMeta || {},
    alias: indexfILmjjvnkOMeta?.alias || [],
    redirect: indexfILmjjvnkOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/index.vue").then(m => m.default || m)
  },
  {
    name: indexfILmjjvnkOMeta?.name ?? "majority-account___es",
    path: indexfILmjjvnkOMeta?.path ?? "/es/cuenta-majority",
    meta: indexfILmjjvnkOMeta || {},
    alias: indexfILmjjvnkOMeta?.alias || [],
    redirect: indexfILmjjvnkOMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/index.vue").then(m => m.default || m)
  },
  {
    name: no_45hidden_45feesnPhZVHZMfIMeta?.name ?? "majority-account-no-hidden-fees",
    path: no_45hidden_45feesnPhZVHZMfIMeta?.path ?? "/majority-account/no-hidden-fees",
    meta: no_45hidden_45feesnPhZVHZMfIMeta || {},
    alias: no_45hidden_45feesnPhZVHZMfIMeta?.alias || [],
    redirect: no_45hidden_45feesnPhZVHZMfIMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-hidden-fees.vue").then(m => m.default || m)
  },
  {
    name: no_45hidden_45feesnPhZVHZMfIMeta?.name ?? "majority-account-no-hidden-fees___en",
    path: no_45hidden_45feesnPhZVHZMfIMeta?.path ?? "/en/majority-account/no-hidden-fees",
    meta: no_45hidden_45feesnPhZVHZMfIMeta || {},
    alias: no_45hidden_45feesnPhZVHZMfIMeta?.alias || [],
    redirect: no_45hidden_45feesnPhZVHZMfIMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-hidden-fees.vue").then(m => m.default || m)
  },
  {
    name: no_45hidden_45feesnPhZVHZMfIMeta?.name ?? "majority-account-no-hidden-fees___es",
    path: no_45hidden_45feesnPhZVHZMfIMeta?.path ?? "/es/cuenta-majority/sin-cargos-ocultos",
    meta: no_45hidden_45feesnPhZVHZMfIMeta || {},
    alias: no_45hidden_45feesnPhZVHZMfIMeta?.alias || [],
    redirect: no_45hidden_45feesnPhZVHZMfIMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-hidden-fees.vue").then(m => m.default || m)
  },
  {
    name: no_45ssnPCCUzpu1TXMeta?.name ?? "majority-account-no-ssn",
    path: no_45ssnPCCUzpu1TXMeta?.path ?? "/majority-account/no-ssn",
    meta: no_45ssnPCCUzpu1TXMeta || {},
    alias: no_45ssnPCCUzpu1TXMeta?.alias || [],
    redirect: no_45ssnPCCUzpu1TXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-ssn.vue").then(m => m.default || m)
  },
  {
    name: no_45ssnPCCUzpu1TXMeta?.name ?? "majority-account-no-ssn___en",
    path: no_45ssnPCCUzpu1TXMeta?.path ?? "/en/majority-account/no-ssn",
    meta: no_45ssnPCCUzpu1TXMeta || {},
    alias: no_45ssnPCCUzpu1TXMeta?.alias || [],
    redirect: no_45ssnPCCUzpu1TXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-ssn.vue").then(m => m.default || m)
  },
  {
    name: no_45ssnPCCUzpu1TXMeta?.name ?? "majority-account-no-ssn___es",
    path: no_45ssnPCCUzpu1TXMeta?.path ?? "/es/cuenta-majority/sin-ssn%20",
    meta: no_45ssnPCCUzpu1TXMeta || {},
    alias: no_45ssnPCCUzpu1TXMeta?.alias || [],
    redirect: no_45ssnPCCUzpu1TXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-account/no-ssn.vue").then(m => m.default || m)
  },
  {
    name: indexPwSNYCGIeoMeta?.name ?? "majority-pay",
    path: indexPwSNYCGIeoMeta?.path ?? "/majority-pay",
    meta: indexPwSNYCGIeoMeta || {},
    alias: indexPwSNYCGIeoMeta?.alias || [],
    redirect: indexPwSNYCGIeoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-pay/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwSNYCGIeoMeta?.name ?? "majority-pay___en",
    path: indexPwSNYCGIeoMeta?.path ?? "/en/majority-pay",
    meta: indexPwSNYCGIeoMeta || {},
    alias: indexPwSNYCGIeoMeta?.alias || [],
    redirect: indexPwSNYCGIeoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-pay/index.vue").then(m => m.default || m)
  },
  {
    name: indexPwSNYCGIeoMeta?.name ?? "majority-pay___es",
    path: indexPwSNYCGIeoMeta?.path ?? "/es/majority-pay",
    meta: indexPwSNYCGIeoMeta || {},
    alias: indexPwSNYCGIeoMeta?.alias || [],
    redirect: indexPwSNYCGIeoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/majority-pay/index.vue").then(m => m.default || m)
  },
  {
    name: indexeLTdsRkRJuMeta?.name ?? "membership-country",
    path: indexeLTdsRkRJuMeta?.path ?? "/membership/:country()",
    meta: indexeLTdsRkRJuMeta || {},
    alias: indexeLTdsRkRJuMeta?.alias || [],
    redirect: indexeLTdsRkRJuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: indexeLTdsRkRJuMeta?.name ?? "membership-country___en",
    path: indexeLTdsRkRJuMeta?.path ?? "/en/membership/:country",
    meta: indexeLTdsRkRJuMeta || {},
    alias: indexeLTdsRkRJuMeta?.alias || [],
    redirect: indexeLTdsRkRJuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: indexeLTdsRkRJuMeta?.name ?? "membership-country___es",
    path: indexeLTdsRkRJuMeta?.path ?? "/es/membresia/:country",
    meta: indexeLTdsRkRJuMeta || {},
    alias: indexeLTdsRkRJuMeta?.alias || [],
    redirect: indexeLTdsRkRJuMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/[country]/index.vue").then(m => m.default || m)
  },
  {
    name: indexHOchfYt3YmMeta?.name ?? "membership",
    path: indexHOchfYt3YmMeta?.path ?? "/membership",
    meta: indexHOchfYt3YmMeta || {},
    alias: indexHOchfYt3YmMeta?.alias || [],
    redirect: indexHOchfYt3YmMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/index.vue").then(m => m.default || m)
  },
  {
    name: indexHOchfYt3YmMeta?.name ?? "membership___en",
    path: indexHOchfYt3YmMeta?.path ?? "/en/membership",
    meta: indexHOchfYt3YmMeta || {},
    alias: indexHOchfYt3YmMeta?.alias || [],
    redirect: indexHOchfYt3YmMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/index.vue").then(m => m.default || m)
  },
  {
    name: indexHOchfYt3YmMeta?.name ?? "membership___es",
    path: indexHOchfYt3YmMeta?.path ?? "/es/membresia",
    meta: indexHOchfYt3YmMeta || {},
    alias: indexHOchfYt3YmMeta?.alias || [],
    redirect: indexHOchfYt3YmMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/membership/index.vue").then(m => m.default || m)
  },
  {
    name: index3dpQQTWCQkMeta?.name ?? "mobile-top-ups",
    path: index3dpQQTWCQkMeta?.path ?? "/mobile-top-ups",
    meta: index3dpQQTWCQkMeta || {},
    alias: index3dpQQTWCQkMeta?.alias || [],
    redirect: index3dpQQTWCQkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/mobile-top-ups/index.vue").then(m => m.default || m)
  },
  {
    name: index3dpQQTWCQkMeta?.name ?? "mobile-top-ups___en",
    path: index3dpQQTWCQkMeta?.path ?? "/en/mobile-top-ups",
    meta: index3dpQQTWCQkMeta || {},
    alias: index3dpQQTWCQkMeta?.alias || [],
    redirect: index3dpQQTWCQkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/mobile-top-ups/index.vue").then(m => m.default || m)
  },
  {
    name: index3dpQQTWCQkMeta?.name ?? "mobile-top-ups___es",
    path: index3dpQQTWCQkMeta?.path ?? "/es/recargas-moviles",
    meta: index3dpQQTWCQkMeta || {},
    alias: index3dpQQTWCQkMeta?.alias || [],
    redirect: index3dpQQTWCQkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/mobile-top-ups/index.vue").then(m => m.default || m)
  },
  {
    name: indexNIiGoS86GaMeta?.name ?? "money-transfers",
    path: indexNIiGoS86GaMeta?.path ?? "/money-transfers",
    meta: indexNIiGoS86GaMeta || {},
    alias: indexNIiGoS86GaMeta?.alias || [],
    redirect: indexNIiGoS86GaMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: indexNIiGoS86GaMeta?.name ?? "money-transfers___en",
    path: indexNIiGoS86GaMeta?.path ?? "/en/money-transfers",
    meta: indexNIiGoS86GaMeta || {},
    alias: indexNIiGoS86GaMeta?.alias || [],
    redirect: indexNIiGoS86GaMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: indexNIiGoS86GaMeta?.name ?? "money-transfers___es",
    path: indexNIiGoS86GaMeta?.path ?? "/es/envios-dinero",
    meta: indexNIiGoS86GaMeta || {},
    alias: indexNIiGoS86GaMeta?.alias || [],
    redirect: indexNIiGoS86GaMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/money-transfers/index.vue").then(m => m.default || m)
  },
  {
    name: indexeRC53bGafdMeta?.name ?? "personalized-advisor",
    path: indexeRC53bGafdMeta?.path ?? "/personalized-advisor",
    meta: indexeRC53bGafdMeta || {},
    alias: indexeRC53bGafdMeta?.alias || [],
    redirect: indexeRC53bGafdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/personalized-advisor/index.vue").then(m => m.default || m)
  },
  {
    name: indexeRC53bGafdMeta?.name ?? "personalized-advisor___en",
    path: indexeRC53bGafdMeta?.path ?? "/en/personalized-advisor",
    meta: indexeRC53bGafdMeta || {},
    alias: indexeRC53bGafdMeta?.alias || [],
    redirect: indexeRC53bGafdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/personalized-advisor/index.vue").then(m => m.default || m)
  },
  {
    name: indexeRC53bGafdMeta?.name ?? "personalized-advisor___es",
    path: indexeRC53bGafdMeta?.path ?? "/es/asesor-personal",
    meta: indexeRC53bGafdMeta || {},
    alias: indexeRC53bGafdMeta?.alias || [],
    redirect: indexeRC53bGafdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/personalized-advisor/index.vue").then(m => m.default || m)
  },
  {
    name: _91category_939yCLdaFxc5Meta?.name ?? "press-category",
    path: _91category_939yCLdaFxc5Meta?.path ?? "/press/:category()",
    meta: _91category_939yCLdaFxc5Meta || {},
    alias: _91category_939yCLdaFxc5Meta?.alias || [],
    redirect: _91category_939yCLdaFxc5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_939yCLdaFxc5Meta?.name ?? "press-category___en",
    path: _91category_939yCLdaFxc5Meta?.path ?? "/en/press/:category",
    meta: _91category_939yCLdaFxc5Meta || {},
    alias: _91category_939yCLdaFxc5Meta?.alias || [],
    redirect: _91category_939yCLdaFxc5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_939yCLdaFxc5Meta?.name ?? "press-category___es",
    path: _91category_939yCLdaFxc5Meta?.path ?? "/es/prensa/:category",
    meta: _91category_939yCLdaFxc5Meta || {},
    alias: _91category_939yCLdaFxc5Meta?.alias || [],
    redirect: _91category_939yCLdaFxc5Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/[category].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93u8ETaza4MoMeta?.name ?? "press-article-slug",
    path: _91slug_93u8ETaza4MoMeta?.path ?? "/press/article/:slug()",
    meta: _91slug_93u8ETaza4MoMeta || {},
    alias: _91slug_93u8ETaza4MoMeta?.alias || [],
    redirect: _91slug_93u8ETaza4MoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93u8ETaza4MoMeta?.name ?? "press-article-slug___en",
    path: _91slug_93u8ETaza4MoMeta?.path ?? "/en/press/article/:slug",
    meta: _91slug_93u8ETaza4MoMeta || {},
    alias: _91slug_93u8ETaza4MoMeta?.alias || [],
    redirect: _91slug_93u8ETaza4MoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93u8ETaza4MoMeta?.name ?? "press-article-slug___es",
    path: _91slug_93u8ETaza4MoMeta?.path ?? "/es/prensa/articulo/:slug",
    meta: _91slug_93u8ETaza4MoMeta || {},
    alias: _91slug_93u8ETaza4MoMeta?.alias || [],
    redirect: _91slug_93u8ETaza4MoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/article/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexZ0fnaTzJDzMeta?.name ?? "press",
    path: indexZ0fnaTzJDzMeta?.path ?? "/press",
    meta: indexZ0fnaTzJDzMeta || {},
    alias: indexZ0fnaTzJDzMeta?.alias || [],
    redirect: indexZ0fnaTzJDzMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ0fnaTzJDzMeta?.name ?? "press___en",
    path: indexZ0fnaTzJDzMeta?.path ?? "/en/press",
    meta: indexZ0fnaTzJDzMeta || {},
    alias: indexZ0fnaTzJDzMeta?.alias || [],
    redirect: indexZ0fnaTzJDzMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/index.vue").then(m => m.default || m)
  },
  {
    name: indexZ0fnaTzJDzMeta?.name ?? "press___es",
    path: indexZ0fnaTzJDzMeta?.path ?? "/es/prensa",
    meta: indexZ0fnaTzJDzMeta || {},
    alias: indexZ0fnaTzJDzMeta?.alias || [],
    redirect: indexZ0fnaTzJDzMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/index.vue").then(m => m.default || m)
  },
  {
    name: _91category_93AkJxdDm0DRMeta?.name ?? "press-material-category",
    path: _91category_93AkJxdDm0DRMeta?.path ?? "/press/material/:category()",
    meta: _91category_93AkJxdDm0DRMeta || {},
    alias: _91category_93AkJxdDm0DRMeta?.alias || [],
    redirect: _91category_93AkJxdDm0DRMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/material/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_93AkJxdDm0DRMeta?.name ?? "press-material-category___en",
    path: _91category_93AkJxdDm0DRMeta?.path ?? "/en/press/material/:category()",
    meta: _91category_93AkJxdDm0DRMeta || {},
    alias: _91category_93AkJxdDm0DRMeta?.alias || [],
    redirect: _91category_93AkJxdDm0DRMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/material/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_93AkJxdDm0DRMeta?.name ?? "press-material-category___es",
    path: _91category_93AkJxdDm0DRMeta?.path ?? "/es/press/material/:category()",
    meta: _91category_93AkJxdDm0DRMeta || {},
    alias: _91category_93AkJxdDm0DRMeta?.alias || [],
    redirect: _91category_93AkJxdDm0DRMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/material/[category].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Uivqn8BKXfMeta?.name ?? "press-tag-slug",
    path: _91slug_93Uivqn8BKXfMeta?.path ?? "/press/tag/:slug()",
    meta: _91slug_93Uivqn8BKXfMeta || {},
    alias: _91slug_93Uivqn8BKXfMeta?.alias || [],
    redirect: _91slug_93Uivqn8BKXfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Uivqn8BKXfMeta?.name ?? "press-tag-slug___en",
    path: _91slug_93Uivqn8BKXfMeta?.path ?? "/en/press/tag/:slug()",
    meta: _91slug_93Uivqn8BKXfMeta || {},
    alias: _91slug_93Uivqn8BKXfMeta?.alias || [],
    redirect: _91slug_93Uivqn8BKXfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93Uivqn8BKXfMeta?.name ?? "press-tag-slug___es",
    path: _91slug_93Uivqn8BKXfMeta?.path ?? "/es/press/tag/:slug()",
    meta: _91slug_93Uivqn8BKXfMeta || {},
    alias: _91slug_93Uivqn8BKXfMeta?.alias || [],
    redirect: _91slug_93Uivqn8BKXfMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/press/tag/[slug].vue").then(m => m.default || m)
  },
  {
    name: team_45majorityCSUsuaGXSJMeta?.name ?? "privacy-policy-team-majority",
    path: team_45majorityCSUsuaGXSJMeta?.path ?? "/privacy-policy/team-majority",
    meta: team_45majorityCSUsuaGXSJMeta || {},
    alias: team_45majorityCSUsuaGXSJMeta?.alias || [],
    redirect: team_45majorityCSUsuaGXSJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityCSUsuaGXSJMeta?.name ?? "privacy-policy-team-majority___en",
    path: team_45majorityCSUsuaGXSJMeta?.path ?? "/en/privacy-policy/team-majority",
    meta: team_45majorityCSUsuaGXSJMeta || {},
    alias: team_45majorityCSUsuaGXSJMeta?.alias || [],
    redirect: team_45majorityCSUsuaGXSJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majorityCSUsuaGXSJMeta?.name ?? "privacy-policy-team-majority___es",
    path: team_45majorityCSUsuaGXSJMeta?.path ?? "/es/privacy-policy/team-majority",
    meta: team_45majorityCSUsuaGXSJMeta || {},
    alias: team_45majorityCSUsuaGXSJMeta?.alias || [],
    redirect: team_45majorityCSUsuaGXSJMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/privacy-policy/team-majority.vue").then(m => m.default || m)
  },
  {
    name: indexDCMBNp3blTMeta?.name ?? "referral",
    path: indexDCMBNp3blTMeta?.path ?? "/referral",
    meta: indexDCMBNp3blTMeta || {},
    alias: indexDCMBNp3blTMeta?.alias || [],
    redirect: indexDCMBNp3blTMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: indexDCMBNp3blTMeta?.name ?? "referral___en",
    path: indexDCMBNp3blTMeta?.path ?? "/en/referral",
    meta: indexDCMBNp3blTMeta || {},
    alias: indexDCMBNp3blTMeta?.alias || [],
    redirect: indexDCMBNp3blTMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: indexDCMBNp3blTMeta?.name ?? "referral___es",
    path: indexDCMBNp3blTMeta?.path ?? "/es/referral",
    meta: indexDCMBNp3blTMeta || {},
    alias: indexDCMBNp3blTMeta?.alias || [],
    redirect: indexDCMBNp3blTMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: indexrHiq7uVcdtMeta?.name ?? "t",
    path: indexrHiq7uVcdtMeta?.path ?? "/t",
    meta: indexrHiq7uVcdtMeta || {},
    alias: indexrHiq7uVcdtMeta?.alias || [],
    redirect: indexrHiq7uVcdtMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/t/index.vue").then(m => m.default || m)
  },
  {
    name: indexrHiq7uVcdtMeta?.name ?? "t___en",
    path: indexrHiq7uVcdtMeta?.path ?? "/en/t",
    meta: indexrHiq7uVcdtMeta || {},
    alias: indexrHiq7uVcdtMeta?.alias || [],
    redirect: indexrHiq7uVcdtMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/t/index.vue").then(m => m.default || m)
  },
  {
    name: indexrHiq7uVcdtMeta?.name ?? "t___es",
    path: indexrHiq7uVcdtMeta?.path ?? "/es/t",
    meta: indexrHiq7uVcdtMeta || {},
    alias: indexrHiq7uVcdtMeta?.alias || [],
    redirect: indexrHiq7uVcdtMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/t/index.vue").then(m => m.default || m)
  },
  {
    name: team_45majoritydfowbWQZUoMeta?.name ?? "terms-and-conditions-team-majority",
    path: team_45majoritydfowbWQZUoMeta?.path ?? "/terms-and-conditions/team-majority",
    meta: team_45majoritydfowbWQZUoMeta || {},
    alias: team_45majoritydfowbWQZUoMeta?.alias || [],
    redirect: team_45majoritydfowbWQZUoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majoritydfowbWQZUoMeta?.name ?? "terms-and-conditions-team-majority___en",
    path: team_45majoritydfowbWQZUoMeta?.path ?? "/en/terms-and-conditions/team-majority",
    meta: team_45majoritydfowbWQZUoMeta || {},
    alias: team_45majoritydfowbWQZUoMeta?.alias || [],
    redirect: team_45majoritydfowbWQZUoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: team_45majoritydfowbWQZUoMeta?.name ?? "terms-and-conditions-team-majority___es",
    path: team_45majoritydfowbWQZUoMeta?.path ?? "/es/terms-and-conditions/team-majority",
    meta: team_45majoritydfowbWQZUoMeta || {},
    alias: team_45majoritydfowbWQZUoMeta?.alias || [],
    redirect: team_45majoritydfowbWQZUoMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-and-conditions/team-majority.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93aoQl1tAxDkMeta?.name ?? "terms-of-use-slug",
    path: _91slug_93aoQl1tAxDkMeta?.path ?? "/terms-of-use/:slug()",
    meta: _91slug_93aoQl1tAxDkMeta || {},
    alias: _91slug_93aoQl1tAxDkMeta?.alias || [],
    redirect: _91slug_93aoQl1tAxDkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93aoQl1tAxDkMeta?.name ?? "terms-of-use-slug___en",
    path: _91slug_93aoQl1tAxDkMeta?.path ?? "/en/terms-of-use/:slug",
    meta: _91slug_93aoQl1tAxDkMeta || {},
    alias: _91slug_93aoQl1tAxDkMeta?.alias || [],
    redirect: _91slug_93aoQl1tAxDkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_93aoQl1tAxDkMeta?.name ?? "terms-of-use-slug___es",
    path: _91slug_93aoQl1tAxDkMeta?.path ?? "/es/terminos-de-uso/:slug",
    meta: _91slug_93aoQl1tAxDkMeta || {},
    alias: _91slug_93aoQl1tAxDkMeta?.alias || [],
    redirect: _91slug_93aoQl1tAxDkMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/[slug].vue").then(m => m.default || m)
  },
  {
    name: index1H25RXLpzdMeta?.name ?? "terms-of-use",
    path: index1H25RXLpzdMeta?.path ?? "/terms-of-use",
    meta: index1H25RXLpzdMeta || {},
    alias: index1H25RXLpzdMeta?.alias || [],
    redirect: index1H25RXLpzdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/index.vue").then(m => m.default || m)
  },
  {
    name: index1H25RXLpzdMeta?.name ?? "terms-of-use___en",
    path: index1H25RXLpzdMeta?.path ?? "/en/terms-of-use",
    meta: index1H25RXLpzdMeta || {},
    alias: index1H25RXLpzdMeta?.alias || [],
    redirect: index1H25RXLpzdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/index.vue").then(m => m.default || m)
  },
  {
    name: index1H25RXLpzdMeta?.name ?? "terms-of-use___es",
    path: index1H25RXLpzdMeta?.path ?? "/es/terminos-de-uso",
    meta: index1H25RXLpzdMeta || {},
    alias: index1H25RXLpzdMeta?.alias || [],
    redirect: index1H25RXLpzdMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/terms-of-use/index.vue").then(m => m.default || m)
  },
  {
    name: atmsng1f35Wya3Meta?.name ?? "visa-debit-card-atms",
    path: atmsng1f35Wya3Meta?.path ?? "/visa-debit-card/atms",
    meta: atmsng1f35Wya3Meta || {},
    alias: atmsng1f35Wya3Meta?.alias || [],
    redirect: atmsng1f35Wya3Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/atms.vue").then(m => m.default || m)
  },
  {
    name: atmsng1f35Wya3Meta?.name ?? "visa-debit-card-atms___en",
    path: atmsng1f35Wya3Meta?.path ?? "/en/visa-debit-card/atms",
    meta: atmsng1f35Wya3Meta || {},
    alias: atmsng1f35Wya3Meta?.alias || [],
    redirect: atmsng1f35Wya3Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/atms.vue").then(m => m.default || m)
  },
  {
    name: atmsng1f35Wya3Meta?.name ?? "visa-debit-card-atms___es",
    path: atmsng1f35Wya3Meta?.path ?? "/es/tarjeta-visa-debito/atms",
    meta: atmsng1f35Wya3Meta || {},
    alias: atmsng1f35Wya3Meta?.alias || [],
    redirect: atmsng1f35Wya3Meta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/atms.vue").then(m => m.default || m)
  },
  {
    name: explore_45discounts8PzlH6xhjHMeta?.name ?? "visa-debit-card-discounts-explore-discounts",
    path: explore_45discounts8PzlH6xhjHMeta?.path ?? "/visa-debit-card/discounts/explore-discounts",
    meta: explore_45discounts8PzlH6xhjHMeta || {},
    alias: explore_45discounts8PzlH6xhjHMeta?.alias || [],
    redirect: explore_45discounts8PzlH6xhjHMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/explore-discounts.vue").then(m => m.default || m)
  },
  {
    name: explore_45discounts8PzlH6xhjHMeta?.name ?? "visa-debit-card-discounts-explore-discounts___en",
    path: explore_45discounts8PzlH6xhjHMeta?.path ?? "/en/visa-debit-card/discounts/explore-discounts",
    meta: explore_45discounts8PzlH6xhjHMeta || {},
    alias: explore_45discounts8PzlH6xhjHMeta?.alias || [],
    redirect: explore_45discounts8PzlH6xhjHMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/explore-discounts.vue").then(m => m.default || m)
  },
  {
    name: explore_45discounts8PzlH6xhjHMeta?.name ?? "visa-debit-card-discounts-explore-discounts___es",
    path: explore_45discounts8PzlH6xhjHMeta?.path ?? "/es/tarjeta-visa-debito/descuentos/explorar-descuentos",
    meta: explore_45discounts8PzlH6xhjHMeta || {},
    alias: explore_45discounts8PzlH6xhjHMeta?.alias || [],
    redirect: explore_45discounts8PzlH6xhjHMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/explore-discounts.vue").then(m => m.default || m)
  },
  {
    name: indexxKHzoabXRXMeta?.name ?? "visa-debit-card-discounts",
    path: indexxKHzoabXRXMeta?.path ?? "/visa-debit-card/discounts",
    meta: indexxKHzoabXRXMeta || {},
    alias: indexxKHzoabXRXMeta?.alias || [],
    redirect: indexxKHzoabXRXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/index.vue").then(m => m.default || m)
  },
  {
    name: indexxKHzoabXRXMeta?.name ?? "visa-debit-card-discounts___en",
    path: indexxKHzoabXRXMeta?.path ?? "/en/visa-debit-card/discounts",
    meta: indexxKHzoabXRXMeta || {},
    alias: indexxKHzoabXRXMeta?.alias || [],
    redirect: indexxKHzoabXRXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/index.vue").then(m => m.default || m)
  },
  {
    name: indexxKHzoabXRXMeta?.name ?? "visa-debit-card-discounts___es",
    path: indexxKHzoabXRXMeta?.path ?? "/es/tarjeta-visa-debito/descuentos",
    meta: indexxKHzoabXRXMeta || {},
    alias: indexxKHzoabXRXMeta?.alias || [],
    redirect: indexxKHzoabXRXMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/discounts/index.vue").then(m => m.default || m)
  },
  {
    name: index3mGdlSOX6BMeta?.name ?? "visa-debit-card",
    path: index3mGdlSOX6BMeta?.path ?? "/visa-debit-card",
    meta: index3mGdlSOX6BMeta || {},
    alias: index3mGdlSOX6BMeta?.alias || [],
    redirect: index3mGdlSOX6BMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/index.vue").then(m => m.default || m)
  },
  {
    name: index3mGdlSOX6BMeta?.name ?? "visa-debit-card___en",
    path: index3mGdlSOX6BMeta?.path ?? "/en/visa-debit-card",
    meta: index3mGdlSOX6BMeta || {},
    alias: index3mGdlSOX6BMeta?.alias || [],
    redirect: index3mGdlSOX6BMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/index.vue").then(m => m.default || m)
  },
  {
    name: index3mGdlSOX6BMeta?.name ?? "visa-debit-card___es",
    path: index3mGdlSOX6BMeta?.path ?? "/es/tarjeta-visa-debito",
    meta: index3mGdlSOX6BMeta || {},
    alias: index3mGdlSOX6BMeta?.alias || [],
    redirect: index3mGdlSOX6BMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/index.vue").then(m => m.default || m)
  },
  {
    name: no_45ssn3jiYEmf6bYMeta?.name ?? "visa-debit-card-no-ssn",
    path: no_45ssn3jiYEmf6bYMeta?.path ?? "/visa-debit-card/no-ssn",
    meta: no_45ssn3jiYEmf6bYMeta || {},
    alias: no_45ssn3jiYEmf6bYMeta?.alias || [],
    redirect: no_45ssn3jiYEmf6bYMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/no-ssn.vue").then(m => m.default || m)
  },
  {
    name: no_45ssn3jiYEmf6bYMeta?.name ?? "visa-debit-card-no-ssn___en",
    path: no_45ssn3jiYEmf6bYMeta?.path ?? "/en/visa-debit-card/no-ssn",
    meta: no_45ssn3jiYEmf6bYMeta || {},
    alias: no_45ssn3jiYEmf6bYMeta?.alias || [],
    redirect: no_45ssn3jiYEmf6bYMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/no-ssn.vue").then(m => m.default || m)
  },
  {
    name: no_45ssn3jiYEmf6bYMeta?.name ?? "visa-debit-card-no-ssn___es",
    path: no_45ssn3jiYEmf6bYMeta?.path ?? "/es/tarjeta-visa-debito/no-ssn",
    meta: no_45ssn3jiYEmf6bYMeta || {},
    alias: no_45ssn3jiYEmf6bYMeta?.alias || [],
    redirect: no_45ssn3jiYEmf6bYMeta?.redirect || undefined,
    component: () => import("/azp/_work/1/s/majority-com/pages/visa-debit-card/no-ssn.vue").then(m => m.default || m)
  }
]